// extracted by mini-css-extract-plugin
export default {"container":"QaUCfNTcLT47cPIc7Ber","wide":"CCdJRyoU6k00RNZew3st","content":"hr7ZEqP6NFo6MRBTZXZc"};